export default () => ({
  root: {
    paddingTop: 32,
    paddingBottom: 32,

    '& div': {
      padding: 0,
      margin: '0px',
      lineHeight: 1,
    },

    '& div:first-child': {
      fontSize: 20,
      fontWeight: 600,
      color: '#27282A',
    },

    '& div:last-child': {
      fontSize: 15,
      color: '#596168',
      marginTop: 16,
    },
  },
});
